<template>
  <modal v-if="show" class="modal-iban" @close="closeModal(null)">
    <h3 slot="header">{{$resx('YourIbanText')}}</h3>
    <template slot="body" v-if="newIban!==null">
      <form @submit.prevent="saveIban">
        <div class="flex">
          <label class="label">{{$resx('IbanNameText')}} *</label>
          <input data-name="name" type="text" required maxlength="50" v-model="newIban.name" />
        </div>
        <div class="flex">
          <label class="label">{{$resx('IbanFirstNameText')}} *</label>
          <input data-name="name" type="text" required maxlength="50" v-model="newIban.firstName" />
        </div>
        <div class="flex">
          <label class="label">{{$resx('IbanLegalNameText')}} *</label>
          <input data-name="name" type="text" required maxlength="100" v-model="newIban.legalName" />
        </div>
        <div class="flex">
          <label class="label">{{$resx('IbanNumberText')}} *</label>
          <input data-name="iban" type="text" required maxlength="40" v-model="newIban.iban" @keydown.space.prevent @paste.space="removeWhiteSpaces" />
        </div>
        <div class="flex">
          <label class="label">{{$resx('BicNumberText')}}</label>
          <input data-name="bic" type="text" maxlength="11" v-model="newIban.bic" @keydown.space.prevent @paste.space="removeWhiteSpaces" />
        </div>
        <div>
          <small>* : {{$resx('MandatoryFieldText')}}</small>
        </div>
        <button class="btn btn-primary" :class="{'is-loading' : isSaving}" type="submit" :disabled="isSaving"><span>{{$resx('SaveText')}}</span></button>
        <button class="btn btn-secondary" type="button" @click="closeModal(null)" :disabled="isSaving">{{$resx('CloseText')}}</button>
      </form>
    </template>
  </modal>
</template>
<script>
import modal from '../modal.vue'
import Iban from '../../models/booking/iban'
import bankServices from '../../services/bankServices'

export default {
  props: {
    show: Boolean,
    iban: Object
  },
  data () {
    return {
      newIban: null,
      isSaving: false
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  methods: {
    // fermeture de la popup
    closeModal (iban) {
      this.$emit('onIbanModalClose', iban)
    },
    // supprimer les espaces au copier/coller
    removeWhiteSpaces (event) {
      if (typeof event.clipboardData !== 'undefined') {
        const text = event.clipboardData.getData('text')
        if (text != null) {
          event.preventDefault()
          // pour montrer à l'internaute qu'il se passe quelque chose s'il copie/colle la même chose
          event.target.value = ''
          this.newIban[event.target.dataset.name] = ''
          this.newIban[event.target.dataset.name] = text.replace(/\s+/g, '').trim()
        }
      }
    },
    // poster l'iban
    async saveIban () {
      try {
        this.isSaving = true
        const response = await bankServices.saveIban(this.currentCampingId, this.newIban)
        this.$store.commit('app/showSnack', { type: 'success', message: response })
        this.closeModal(this.newIban)
        this.newIban = new Iban()
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      } finally {
        this.isSaving = false
      }
    }
  },
  components:
  {
    modal: modal
  },
  mounted: function () {
    this.newIban = new Iban()
  }
}
</script>
<style lang="less">
  @import '../../assets/variables.less';

 .modal-iban{
    .modal-container
    {
      max-width: 60em;
    }

  h3 {
    font-family:'Playfair Display';
    font-weight: @fontBold;
    font-size: 3em!important;
    color:white!important;
    margin-bottom:1em!important;
  }

  form {
    margin:0 auto;
    max-width:35em;

    >div
    {
      width:100%;
      margin:1em 0;
    }

    label {
      width: 40%;
    }

    input{
      border-radius:4px;
      padding:.25em 1em;
      background-color:rgba(255,255,255,0.05);
      color:white;
      border:none;
      width:60%;
    }
  }

  label, small{
    color: white;
  }

  button+button{
    margin-left:1em;
  }

  }
</style>
